import { Component, Input, OnChanges } from "@angular/core";
import { ItemTableRow } from "src/services/datatable/datatable.interface";
import { ItemRowClickEvent } from "src/services/datatable/datatable.types";
import { NavigationService } from "src/services/navigation/navigation.service";
import { PlanUniqueId } from "../../../../../services/subscription-type/subscription-type.interface";
import { tryParseDate } from "src/services/utils/timestamp.utils";
import { Item } from "src/services/item/item.interface";
import { rackToString } from "src/services/item/rack.interface";
import { itemCategoryToString, itemNameToString } from "src/services/item/item-display";

export enum ItemTableColumn {
  category = "category",
  image = "image",
  location = "location",
  name = "name",
  numberId = "numberId",
  reclaimedAt = "reclaimedAt",
  status = "status",
}

export type ItemTableColumnVisible = {
  [column in ItemTableColumn]: boolean;
};

@Component({
  selector: "rc-item-table",
  templateUrl: "./item-table.component.html",
  styleUrls: ["./item-table.component.scss"],
  standalone: false,
})
export class ItemTableComponent implements OnChanges {
  @Input() columnVisible: ItemTableColumnVisible;
  @Input() items: Item[];
  @Input() searchStringToHighlight: string | undefined;

  public tableRows: ItemTableRow[] = [];

  public constructor(private readonly navigationService: NavigationService) {}

  public ngOnChanges() {
    if (!this.items) {
      return;
    }

    if (!this.columnVisible) {
      this.columnVisible = {
        category: true,
        image: true,
        location: true,
        name: false,
        numberId: true,
        reclaimedAt: false,
        status: true,
      };
    }

    this.populateItemRows();
  }

  public async goToItem(event: ItemRowClickEvent) {
    if (event.type !== "click") {
      return;
    }

    await this.navigationService.goToItemDetailsPage(event.row.id);
  }

  private populateItemRows() {
    const tableRows: ItemTableRow[] = [];

    this.items.forEach((item: Item) => {
      tableRows.push({ ...item, location: rackToString(item) });
    });

    this.tableRows = tableRows;
  }

  public readonly PlanUniqueId = PlanUniqueId;
  public readonly tryParseDate = tryParseDate;
  public readonly itemCategoryToString = itemCategoryToString;
  public readonly itemNameToString = itemNameToString;
}
